import meta from '#utilities/js/ea/meta.js'
import worker from '#utilities/js/ea/worker.js'

const { URL } = globalThis
const { parseInt } = Number

const type = 'pow'

const options = {
  type: 'classic',
  credentials: 'same-origin'
}

export default (
  input
) => {
  const { dataset, name, ownerDocument } = input
  const { currentScript, location } = ownerDocument
  const { challenge, length, prefix } = dataset
  const value = { challenge, length: parseInt(length, 10), prefix }
  const [raw] = meta('worker', input)
  const url = new URL(raw, location)

  if (currentScript?.noModule) {
    const { pathname } = url

    url.pathname = pathname.replace(
      /([^/]+?)(\..+)$/,
      "$1-legacy$2"
    )
  }

  queueMicrotask(async () => {
    const responses = worker(input, `${url}`, type, value, options)

    for await (const { value } of responses) {
      input.value = value
      break
    }

    return responses.return()
  })
}
